import { render, staticRenderFns } from "./StudentFaceModal.vue?vue&type=template&id=076fd905"
import script from "./StudentFaceModal.vue?vue&type=script&lang=js"
export * from "./StudentFaceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('076fd905')) {
      api.createRecord('076fd905', component.options)
    } else {
      api.reload('076fd905', component.options)
    }
    module.hot.accept("./StudentFaceModal.vue?vue&type=template&id=076fd905", function () {
      api.rerender('076fd905', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/studentFace/modules/StudentFaceModal.vue"
export default component.exports